import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
} from "@material-ui/core";
import { DatePicker } from "@ofqual/portal-components/components/DatePicker";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { ApproveApplication } from "../../../domain/ApproveApplication";
import { approveApplication } from "../../../redux/actions";
import { Error } from "../../common/Error";

type ApproveButtonAndDialogProps = {
  orgId: string;
  applicationId: string;
};

export const ApproveButtonAndDialog: React.FC<ApproveButtonAndDialogProps> = (
  props
) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <AppBarButton data-test="approve-button" text="Approve" onClick={() => setIsOpen(true)} />
      {isOpen && <ApproveDialog {...props} onClose={() => setIsOpen(false)} />}
    </>
  );
};

type ApproveDialogProps = {
  orgId: string;
  applicationId: string;
  onClose: () => void;
};

const ApproveDialog: React.FC<ApproveDialogProps> = ({
  orgId,
  applicationId,
  onClose,
}) => {
  const dispatch = useDispatch();
  const { control, errors, handleSubmit } = useForm({
    defaultValues: { recognisedOn: "" } as ApproveApplication,
  });

  const onSubmit = (model: ApproveApplication) => {
    dispatch(approveApplication(orgId, applicationId, model));
    onClose();
  };

  return (
    <>
      <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Approve this Application?</DialogTitle>
        <Divider component="div" />
        <DialogContent>
          <form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Controller
                  name="recognisedOn"
                  rules={{
                    required: true,
                  }}
                  control={control}
                  as={<DatePicker dataTest="approve-recognised-on" label="Recognised On (dd/mm/yyyy)" />}
                />
                {errors.recognisedOn && <Error>This field is required</Error>}
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button data-test="approve-confirm" onClick={handleSubmit(onSubmit)} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
